export const getArrayItemByIndex = <T>(index: number, arr: T[]): T =>
  arr[index % arr.length];

export const mergeObjectArrays = <T extends Record<string, unknown>>(
  firstArr: T[],
  secondArr: T[],
  compareProperty: string,
) => {
  const accumulationResult = [...firstArr];

  secondArr.forEach((secondArrItem) => {
    const secondArrItemInFirst = firstArr.find(
      (firstArrItem) =>
        firstArrItem[compareProperty] === secondArrItem[compareProperty],
    );

    if (secondArrItemInFirst) return;

    accumulationResult.push(secondArrItem);
  });

  return accumulationResult;
};

export const getTwoArraysIntersection = (
  firstArr: unknown[],
  secondArr: unknown[],
) =>
  firstArr.filter((firstArrItem) =>
    secondArr.some((secondArrItem) => Object.is(firstArrItem, secondArrItem)),
  );
